import React from 'react'
import { NavLink } from 'react-router-dom'

import { ITabsProps, ITab, TLinks } from './Tabs.interface'
import './styles.scss'

const bc = 'tabs'

export const createdLinksHelper = (baseLink: string, links: TLinks): TLinks => {
  return links.map(
    (link: ITab): ITab => {
      return {
        name: link.name,
        path: baseLink + link.path,
      }
    }
  )
}

const Tabs: React.FC<ITabsProps> = ({ t, links }) => (
  <div className={bc}>
    {links.map((link, index) => (
      <div key={`${link.path}__${index}`} className={`${bc}__item`}>
        <NavLink to={link.path} className={`${bc}__link`} activeClassName="active">
          {t(link.name)}
        </NavLink>
      </div>
    ))}
  </div>
)

export default Tabs
